const template = document.createElement("template");
template.innerHTML = `
<style>
  :host{
    display: block;
    font-family: var(--ctl-font-sans, system-ui,-apple-system,Segoe UI,Roboto,Arial);
  }

  .list{
    display: flex;
    flex-direction: column;
    border-radius: var(--ctl-radius-lg);
    border: 1px solid var(--ctl-color-border);
    background: var(--ctl-color-surface);
    overflow: hidden;
  }

  /* borderless variant */
  :host([borderless]) .list{
    border: none;
    border-radius: 0;
  }

  /* divided variant - adds dividers between items */
  :host([divided]) ::slotted(ctl-list-item:not(:last-child)){
    border-bottom: 1px solid var(--ctl-color-border);
  }

  /* compact density */
  :host([density="compact"]) {
    --ctl-list-item-padding: var(--ctl-space-2) var(--ctl-space-3);
  }

  :host(:not([density]), [density="comfortable"]) {
    --ctl-list-item-padding: var(--ctl-space-3) var(--ctl-space-4);
  }
</style>

<div class="list" part="list" role="list">
  <slot></slot>
</div>
`;

export class CtlList extends HTMLElement {
  static get observedAttributes() {
    return ["density", "divided", "borderless"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    // defaults
    if (!this.hasAttribute("density")) this.setAttribute("density", "comfortable");
    this._normalize();
  }

  attributeChangedCallback() {
    this._normalize();
  }

  // attrs
  get density() { return this.getAttribute("density") || "comfortable"; }
  set density(v) { this.setAttribute("density", String(v || "comfortable")); }

  get divided() { return this.hasAttribute("divided"); }
  set divided(v) { v ? this.setAttribute("divided", "") : this.removeAttribute("divided"); }

  get borderless() { return this.hasAttribute("borderless"); }
  set borderless(v) { v ? this.setAttribute("borderless", "") : this.removeAttribute("borderless"); }

  _normalize() {
    const density = this.density;
    if (!["comfortable", "compact"].includes(density)) {
      this.setAttribute("density", "comfortable");
    }
  }
}

customElements.define("ctl-list", CtlList);
